import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { avatarService } from '@/services/avatar';
import { computed } from 'vue';

export function useAvatarColorList() {
    const { list, total, fetchList } = useBaseListView({ request: avatarService.color.list });

    const colorOption = computed(() => list.value.map(c => ({ label: c.name, value: c.id })));
    const colorMap = computed(() => new Map(list.value.map(c => [c.id, c])));

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: avatarService.color.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions, colorOption, colorMap };
}
